import { SatellitePage } from "../SatellitePage";

export default class OrderSatellitePage extends SatellitePage {
    public static URL_ADDTOCART = '/satellite/addtocart';
    public static PRODUCT_BASE = 708;

    private $error: JQuery;
    private $products: JQuery;
    private $submit: JQuery;

    private satelliteuser: boolean;

    private errtimer: any;

    public onInit(): void {
        this.$error = $('.satellite-order__error', this.$el);
        this.$products = $('.satellite-order__product', this.$el);
        const $inputs = $('input', this.$products);
        this.$submit = $('.satellite-order__submit', this.$el);

        this.satelliteuser = this.$el.data('ut') == '1';

        $inputs.on('change', () => {
            this.updateLayout();
        });

        this.$submit.on('click', (e) => {
            e.preventDefault();

            try {
                const ids = this.getSelectedProducts();

                $.post(OrderSatellitePage.URL_ADDTOCART, {ids: ids}, (r) => {
                    if (r.success) {
                        if (r.redirect) {
                            window.location = r.redirect;
                        }
                    } else if (r.error) {
                        this.showError(r.message);
                    } else {
                        this.showError('Wystąpił błąd z połączeniem.');
                    }
                }).fail(() => {
                    this.showError('Wystąpił błąd z połączeniem.');
                });
            } catch (e) {
                this.showError(e);
            }
        });

        this.updateLayout();
    }

    public showError(str: string): void {
        this.$error.hide();
        this.$error.html(str);
        this.$error.slideDown();


        if (this.errtimer) {
            clearTimeout(this.errtimer);
            this.errtimer = null;
        }

        this.errtimer = setTimeout(() => {
            this.$error.slideUp();
        }, 5000);
    }

    public updateLayout(): void {
        let canorder = true;

        try {
            this.validate();
        } catch (e) {
            canorder = false;
        }

        const ids = this.getSelectedProducts();

        if (!this.satelliteuser) {
            const $first = this.$products.first();
            const $rest = this.$products.not($first);

            const basesel = ids.length > 0 && ids[0] == OrderSatellitePage.PRODUCT_BASE;

            if (basesel) {
                $rest.slideDown();
            } else {
                $rest.slideUp();
            }
        }

        this.$submit.prop('disabled', !canorder);
    }

    public validate(): void {
        const ids = this.getSelectedProducts();

        if (ids.length == 0) {
            throw 'Nie wybrano produktów';
        }

        if (!this.satelliteuser) {
            const basesel = ids[0] == OrderSatellitePage.PRODUCT_BASE;

            if (!basesel) {
                throw 'Należy zaznaczyć kombajn.';
            }
        }
    }

    private getSelectedProducts(): number[] {
        const $inputs = $('input:checked:visible', this.$products)

        let result: number[] = [];

        $inputs.each((ix, el) => {
            const $input = $(el);

            result.push(parseInt($input.val()));
        });

        return result;
    }
}
